import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { FormControl } from "./FormControl";
import { FormContext } from "./FormContext";
import { useConfig } from "../_util/config-context";
import { Bubble } from "../bubble";
import { Icon } from "../icon";
export var FormItem = React.forwardRef(function FormItem(_a, ref) {
    var htmlFor = _a.htmlFor, label = _a.label, children = _a.children, status = _a.status, message = _a.message, extra = _a.extra, align = _a.align, required = _a.required, tips = _a.tips, _b = _a.showStatusIcon, showStatusIcon = _b === void 0 ? true : _b, suffix = _a.suffix, className = _a.className, props = __rest(_a, ["htmlFor", "label", "children", "status", "message", "extra", "align", "required", "tips", "showStatusIcon", "suffix", "className"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement(FormContext.Consumer, null, function (_a) {
        var hideLabel = _a.hideLabel, fixedLabelWidth = _a.fixedLabelWidth;
        return (React.createElement("div", __assign({ ref: ref, className: classNames(classPrefix + "-form__item", className) }, props),
            !hideLabel && (React.createElement("div", { className: classNames(classPrefix + "-form__label", {
                    "is-required": required,
                }) }, typeof label !== "undefined" && (React.createElement("label", { htmlFor: htmlFor, style: fixedLabelWidth ? { width: fixedLabelWidth } : undefined },
                label,
                tips && (React.createElement(React.Fragment, null,
                    " ",
                    React.createElement(Bubble, { content: tips },
                        React.createElement(Icon, { type: "info" })))))))),
            React.createElement(FormControl, { status: status, showStatusIcon: showStatusIcon, message: message, extra: extra, alignLabelTop: isAlignLabelTop(align, children) },
                children,
                suffix && (React.createElement("div", { className: classPrefix + "-form__help-text--inline" }, suffix)))));
    }));
});
FormItem.displayName = "FormItem";
function isAlignLabelTop(align, children) {
    if (align === "top") {
        return true;
    }
    if (align === "middle") {
        return false;
    }
    return getDefaultAlign(children) === "top";
}
function getDefaultAlign(control) {
    if (React.isValidElement(control) &&
        // 普通组件是 function, forwaredRef 是 object
        (typeof control.type === "function" || typeof control.type === "object") &&
        "defaultLabelAlign" in control.type) {
        return control.type["defaultLabelAlign"]; // eslint-disable-line dot-notation
    }
    return "top";
}
//# sourceMappingURL=FormItem.js.map